export default __webpack_public_path__ + "static/media/dianoiva_8.003b47cc.jpg";